import React from 'react';
import { Icon } from '@npm-registry/eapteka-ui';
import Styles from './Loader.scss';

export const Loader = () => (
  <div className={Styles.loader}>
    <Icon name="loader" />
  </div>
);
